import { Component } from '@angular/core';
import { Auth, AuthService } from './pages/login/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  public title: string = 'ADLUUX'

  constructor(private auth: AuthService, private router: Router) {

  }

  // define what is home link (when pressing home /ADLUUX button image/)
  public defineHomeLink() {
    var auth = this.auth.getAuth()

    if (auth.isManager()) {
      return 'admin/approval';
    } else if (auth.isMaintainer()) {
      return 'admin/devices';
    } else {
      // admin or customer or landing
      return '/';
    }
  }

  // check if user is authorized (has it's ID in database)
  public authorized() {
    return this.auth.getAuth().isAuthorized();
  }

  // check if Admin user
  public admin() {
    return this.auth.getAuth().isAdmin();
  }

  // check if Manager or Admin user
  public managerOrAdmin() {
      var auth = this.auth.getAuth();
      return auth.isManager() || auth.isAdmin();
  }

  // check if Maintainer or Admin user
  public maintainerOrAdmin() {
    var auth = this.auth.getAuth();
    return auth.isMaintainer() || auth.isAdmin();
  }

  // check if any user that has administration rights (Admin/Manager/Maintainer)
  public administrationUser() {
    var auth = this.auth.getAuth();
    return auth.isManager() || auth.isAdmin() || auth.isMaintainer();
  }

  // check if user is banned
  public banned() {
	  return this.auth.getAuth().isBanned();
  }

  // logout user
  public logout() {
    this.auth.logout().then(res => {
      this.router.navigate(['']);
    });
  }

  // check if landing page
  public isLanding() {
    return this.router.url === "/" || this.router.url.startsWith("/#");
  }

  // check if login or register page
  public isAuth() {
    return this.router.url === "/login" || this.router.url === "/register";
  }

  // check if dashboard page
  public isDashboard() {
    return this.router.url === "/dashboard";
  }
}



// WEBPACK FOOTER //
// /Users/gordan.o@nylas.com/Documents/GitHub/adluux/adluux-frontend/src/app/app.component.ts